import axios from "axios";
import Config from "../utils/Config";

class SettingService{
    config = {
        headers: {
            Authorization: "",
            GroupId: "",
            CompanyId: "",
        },
    };

    setAccessToken(accessToken, groupId, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.GroupId = groupId;
        this.config.headers.CompanyId = companyId;
    }

    //upload profile picture
    async uploadProfilePicture(accessToken, groupId, companyId, userId, profilePicture) {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + `/api/user/${userId}/upload-profile-picture`, ///api/user/{userId}/upload-profile-picture
          profilePicture,
          this.config
        )
        return data.data;
      }

    //upload Company profile picture
    async uploadCompanyProfilePicture(accessToken, groupId, companyId, profilePicture) {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.post(
          Config.BACKEND_URL + `/api/company/upload-logo/${companyId}`, //api/company/upload-logo/{companyId}
          profilePicture,
          this.config
        )
        return data.data;

      }
    
    //Delete Company profile picture
    async deleteCompanyProfilePicture(accessToken, groupId, companyId) {
      this.setAccessToken(accessToken, groupId, companyId);
      const data = await axios.delete(
        Config.BACKEND_URL + `/api/company/delete-company-logo/${companyId}`, //api/company/delete-company-logo/{companyId}
        this.config
      )
      return data.data;

    }

    async getManageProfileLink(accessToken, groupId, companyId) {
        this.setAccessToken(accessToken, groupId, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + "/api/user/manage-profile-link",
            this.config
        );
        return data.data;
    }
};

export default new SettingService();